const numDifferentiation = (val, point) => {
  if (val >= 10000000) {
    val = (val / 10000000).toFixed(point)
    val = parseFloat(val) + " Crore"
  } else if (val >= 100000) {
    val = (val / 100000).toFixed(point)
    val = parseFloat(val) + " Lakh"
  } else {
    val = parseFloat(val).toFixed(0)
    val = (val + "").replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")
  }
  return val
}

// functions to add commas
const addCommas = (nStr) => {
  return nStr.toString().replace(/(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g, "$1,")
}

// functions to remove commas
const removeCommas = (numWidCommas) => {
  return numWidCommas.replace(/[,]/g, '')
}

const downloadFile = (url, fileName) => {
  var element = document.createElement('a')
  element.setAttribute('href', url)
  element.setAttribute('download', fileName)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

const numConvert = (n) => {
  let ord = ["st", "nd", "rd"]
  let exceptions = [11, 12, 13]
  let nth = ord[(n % 10) - 1] === undefined || exceptions.includes(n % 100) ? "th" : ord[(n % 10) - 1]
  return n + nth
}

const scrollToClass = (target, type = 'smooth') => {
  var element = document.getElementsByClassName(target)[0]
  element.scrollIntoView({ behavior: type, block: 'center' })
  // console.info("ScrollToClass :", target)
}

const scrollToClassHorizon = (target) => {
  var element = document.querySelector(`.${target}`)
  // console.info("ScrollToClass :", element)
  element.scrollIntoView({ behavior: "smooth", block: 'center', inline: "center", })

}

const handleClassClick = (target) => {
  var element = document.querySelector(`.${target}`)
  element.click()
}

const scrollPatch = (type) => {
  setTimeout(() => {
    try {
      var contentWrapper = document.getElementsByTagName("body")[0]
      if (contentWrapper.hasAttribute("style")) {
        contentWrapper.style.overflow = type
      }
    } catch { }
  }, 1000)
}

const scrollToId = (target) => {
  var element = document.getElementById(target)
  element.scrollIntoView({ behavior: 'smooth', block: 'center' })
}

const mergeTwoObj = (array1, array2, mergeKey) => {
  const resultArray = array1.map(x => ({ ...x, ...array2.find(y => y[mergeKey] === x[mergeKey]) }))

  return resultArray
}

const mergeByProperty = async (origArr, updatingArr, mergeKey) => {
  var value = await origArr.map(function (a) {
    return this[a[mergeKey]] || a
  }, updatingArr.reduce(function (r, a) {
    r[a[mergeKey]] = a
    return r
  }, Object.create(null)))
  value = await mergeTwoObj(origArr, value, mergeKey)
  return value
}

const getValueFromJsonObj = (object, keyVal, returnKey) => {
  for (var key in object) {
    if (key === keyVal)
      return object[keyVal][returnKey]
  }
  return ""
}

const getCookieBoi = (cname) => {
  try {
    var name = cname + "="
    var data = (document.cookie).split('encryptedCookie=')
    var UserDataJSON = window.blowfish['decrypt'](data[1], "!t@a6@($%(", { outputType: 0, cipherMode: 0 })
    UserDataJSON = UserDataJSON.split('&ends')[0]
    var ca = UserDataJSON.split('&')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ""
  } catch (err) {
    //console.log("personalization tag is not available. "+err);
  }
}

const getStorageBoi = (key) => {
  try {
    var value = JSON.parse(window.$.jCryptionDIGI.decrypt(localStorage.getItem(key), "encrypt"))
    // console.info("getStorageBoi Value :", window.UserInput.dob, value.dob)
    if (window.UserInput.dob === value.dob) {
      // console.log('value matched')
      window.localDobFlag = true
      return value
    }
  } catch (e) {
    // console.log('getStorage: Error reading key [' + key + '] from localStorage: ' + JSON.stringify(e))
    return null
  }
}

const isJson = (str) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

const capitalize = (str) => {
  try {
    return str[0].toUpperCase() + str.slice(1)
  } catch {
    return str
  }
}
const GrabToHScroll = (target) => {
  const slider = document.querySelector(`.${target}`)
  let mouseDown = false
  let startX, scrollLeft
  let startDragging = function (e) {
    mouseDown = true
    startX = e.pageX - slider.offsetLeft
    scrollLeft = slider.scrollLeft
  }
  let stopDragging = function (event) {
    mouseDown = false
    if (slider.classList.contains("Grabbing")) slider.classList.remove("Grabbing")
    slider.classList.add("Grab")
  }

  slider.addEventListener("mousemove", (e) => {
    e.preventDefault()
    if (!mouseDown) {
      return
    }
    if (slider.classList.contains("Grab")) slider.classList.remove("Grab")
    slider.classList.add("Grabbing")
    const x = e.pageX - slider.offsetLeft
    const scroll = x - startX
    slider.scrollLeft = scrollLeft - scroll
  })

  slider.addEventListener("mousedown", startDragging, false)
  slider.addEventListener("mouseup", stopDragging, false)
  slider.addEventListener("mouseleave", stopDragging, false)
}

const num_to_words = (num) => {
  let single_digits = ["", "One ", "Two ", "Three ", "Four ", "Five ", "Six ", "Seven ", "Eight ", "Nine ", "Ten ", "Eleven ", "Twelve ", "Thirteen ", "Fourteen ", "Fifteen ", "Sixteen ", "Seventeen ", "Eighteen ", "Nineteen "]
  let tens_multiple = ["", "", "Twenty ", "Thirty ", "Forty ", "Fifty ", "Sixty", "Seventy ", "Eighty ", "Ninety ", "Hundred"]
  if ((num = num.toString()).length > 10) return "overflow";
  let n = ("0000000000" + num).substr(-10).match(/^(\d{1})(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return;
  var str = "";
  str += n[1] != 0 ? (single_digits[Number(n[1])] || tens_multiple[n[1][0]] + " " + single_digits[n[1][1]]) + "Hundred Crore " : "";
  str += n[2] != 0 ? (single_digits[Number(n[2])] || tens_multiple[n[2][0]] + " " + single_digits[n[2][1]]) + "Crore " : "";
  str += n[3] != 0 ? (single_digits[Number(n[3])] || tens_multiple[n[3][0]] + " " + single_digits[n[3][1]]) + "Lakh " : "";
  str += n[4] != 0 ? (single_digits[Number(n[4])] || tens_multiple[n[4][0]] + " " + single_digits[n[4][1]]) + "Thousand " : "";
  str += n[5] != 0 ? (single_digits[Number(n[5])] || tens_multiple[n[5][0]] + " " + single_digits[n[5][1]]) + "Hundred " : "";
  str += n[6] != 0 ? (str != "" ? "and " : "") + (single_digits[Number(n[6])] || tens_multiple[n[6][0]] + " " + single_digits[n[6][1]]) + "only" : "";
  return str;
}

export {
  numDifferentiation, removeCommas, addCommas, downloadFile, numConvert, scrollPatch, scrollToClass,
  scrollToClassHorizon, handleClassClick, scrollToId, mergeTwoObj, mergeByProperty, getValueFromJsonObj,
  getCookieBoi, getStorageBoi, isJson, capitalize, num_to_words,GrabToHScroll
}
